import { makeIndex, makeIndexType, getFileName } from '@jbrowse/core/util/tracks';
export default (function (pluginManager) {
  pluginManager.addToExtensionPoint('Core-guessAdapterForLocation', function (adapterGuesser) {
    return function (file, index, adapterHint) {
      var regexGuess = /\.cram$/i;
      var adapterName = 'CramAdapter';
      var fileName = getFileName(file);
      var obj = {
        type: adapterName,
        cramLocation: file,
        craiLocation: index || makeIndex(file, '.crai')
      };
      if (regexGuess.test(fileName) && !adapterHint) {
        return obj;
      } else if (adapterHint === adapterName) {
        return obj;
      }
      return adapterGuesser(file, index, adapterHint);
    };
  });
  pluginManager.addToExtensionPoint('Core-guessAdapterForLocation', function (adapterGuesser) {
    return function (file, index, adapterHint) {
      var regexGuess = /\.bam$/i;
      var adapterName = 'BamAdapter';
      var fileName = getFileName(file);
      var indexName = index && getFileName(index);
      var obj = {
        type: adapterName,
        bamLocation: file,
        index: {
          location: index || makeIndex(file, '.bai'),
          indexType: makeIndexType(indexName, 'CSI', 'BAI')
        }
      };
      if (regexGuess.test(fileName) && !adapterHint) {
        return obj;
      } else if (adapterHint === adapterName) {
        return obj;
      }
      return adapterGuesser(file, index, adapterHint);
    };
  });
  pluginManager.addToExtensionPoint('Core-guessTrackTypeForLocation', function (trackTypeGuesser) {
    return function (adapterName) {
      if (adapterName === 'BamAdapter' || adapterName === 'CramAdapter') {
        return 'AlignmentsTrack';
      }
      return trackTypeGuesser(adapterName);
    };
  });
});